<template>
	<div class="no-search-results">
		<SearchIcon type="regular" halo />
		{{ $t('common_search_no_results', { Term: query }) }}
		<slot />
	</div>
</template>

<script>
import { SearchIcon } from '@/icons'

export default {
	name: 'NoSearchResults',
	components: { SearchIcon },
	props: {
		query: String,
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.no-search-results {
	@include flex-column-center;
	font-size: 24px;
	color: var(--neutral-800);
	.pronto-icon {
		font-size: 75px;
		color: var(--blue-300);
		margin-bottom: 24px;
	}
}
</style>
